/** The backend's `{error: "..."}` message when it sent one, otherwise `fallback`. */
export default function errorMessage(err, fallback) {
  const serverMessage = err?.response?.data?.error;
  return typeof serverMessage === 'string' && serverMessage ? serverMessage : fallback;
}
